import { useEffect, useMemo, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getUserBps } from 'features/bpList/ducks/selectors'
import { fetchUserBpsRoutine } from 'features/bpList/ducks/actions'
import { listPortfoliosRoutine } from 'ducks/portfolio/actions'
import { selectPortfolioList } from 'ducks/portfolio/selectors'
import { selectHasPortfoliosAccess } from 'features/auth/ducks/selectors'
import { PillSelect } from './FilterControls'

const byLabel = (a, b) => a.label.localeCompare(b.label)

const ScopePickers = ({ bp, portfolio, onChoose, scopedBps = null, showPortfolio = true }) => {
  const dispatch = useDispatch()
  const hasPortfoliosAccess = useSelector(selectHasPortfoliosAccess)
  const userBpsRaw = useSelector(getUserBps)
  const portfoliosRaw = useSelector(selectPortfolioList)
  const hasScoped = Array.isArray(scopedBps) && scopedBps.length > 0
  const wantPortfolios = showPortfolio && hasPortfoliosAccess
  const needBps = !hasScoped && (!Array.isArray(userBpsRaw) || userBpsRaw.length === 0)
  const needPortfolios = wantPortfolios && (!Array.isArray(portfoliosRaw) || portfoliosRaw.length === 0)

  const firstNeeds = useRef({ needBps, needPortfolios })

  useEffect(() => {
    const needs = firstNeeds.current
    if (needs.needBps) dispatch(fetchUserBpsRoutine({ page: 1, sort: '-created_at' }))
    if (needs.needPortfolios) dispatch(listPortfoliosRoutine())
  }, [dispatch])

  const bpOptions = useMemo(() => {
    const source = hasScoped ? scopedBps : (Array.isArray(userBpsRaw) ? userBpsRaw : [])
    const list = source
      .filter(item => hasScoped || item.hasTaskManagement)
      .map(item => ({ value: item.id, label: item.name || item.address || 'Building Passport' }))
      .sort(byLabel)
    if (bp && !list.some(option => option.value === bp)) list.unshift({ value: bp, label: 'Chosen Building Passport' })
    return list
  }, [hasScoped, scopedBps, userBpsRaw, bp])

  const portfolioOptions = useMemo(() => {
    const list = (Array.isArray(portfoliosRaw) ? portfoliosRaw : [])
      .map(item => ({ value: item.id, label: item.name || 'Unnamed portfolio' }))
      .sort(byLabel)
    if (portfolio && !list.some(option => option.value === portfolio)) list.unshift({ value: portfolio, label: 'Chosen portfolio' })
    return list
  }, [portfoliosRaw, portfolio])

  return (
    <>
      {bpOptions.length > 0 && (
        <PillSelect
          $active={!!bp}
          value={bp}
          onChange={value => onChoose('bp', value)}
          options={bpOptions}
          clearable
          clearLabel='All Building Passports'
          placeholder='Building Passport'
          searchPlaceholder='Search Building Passports'
          ariaLabel='Show remedials for one Building Passport'
        />
      )}
      {wantPortfolios && portfolioOptions.length > 0 && (
        <PillSelect
          $active={!!portfolio}
          value={portfolio}
          onChange={value => onChoose('portfolio', value)}
          options={portfolioOptions}
          clearable
          clearLabel='All portfolios'
          placeholder='Portfolio'
          searchPlaceholder='Search portfolios'
          ariaLabel='Show remedials for one portfolio'
        />
      )}
    </>
  )
}

export default ScopePickers
